module.exports = __webpack_public_path__ + "img/reduce-downtime-depth1.b2dd615c.png";